<template>
  <div class="payment-failed-container py-5 mt-5 mb-5">
    <div class="container text-center">
      <div class="card p-5 shadow-sm">
        <i class="fa fa-times-circle text-danger fa-5x"></i>
        <h2 class="text-danger mt-3">{{ $t("payment.failedTitle") }}</h2>
        <p class="mt-2">{{ $t("payment.failedMessage") }}</p>

        <div class="alert alert-warning mt-3">
          <i class="fa fa-info-circle"></i> {{ $t("payment.tryAgain") }}
        </div>

        <div class="d-flex justify-content-center gap-3 mt-4">
          <router-link to="/bilete" class="btn btn-outline-danger">
            <i class="fa fa-refresh"></i> {{ $t("payment.retryPayment") }}
          </router-link>

          <router-link to="/" class="btn btn-primary">
            <i class="fa fa-home"></i> {{ $t("payment.returnHome") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.payment-failed-container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.card {
  border-radius: 10px;
  background: white;
}
.alert-warning {
  font-size: 1rem;
}
</style>
